import ApiService from 'services/api.service';

class SupportCommunityService {
    static async getLoginUrl() {
        const apiService = new ApiService();

        return await apiService
            .get('supportcommunity/loginUrl')
            .then(({ data: { loginUrl } }) => loginUrl)
            .catch(error => {
                if (error.response.status === 500) {
                    return '/support-training/coming-soon';
                }
            });
    }
}

export default SupportCommunityService;
